import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  async handleError(error: any): Promise<void> {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const moduleScriptFailed = /Failed to load module script/;
    const mimeTypeError = /MIME type.*text\/html/;

    const errorMessage = error?.message || error?.toString() || '';

    if (
      chunkFailedMessage.test(errorMessage) ||
      moduleScriptFailed.test(errorMessage) ||
      mimeTypeError.test(errorMessage)
    ) {
      try {
        if ('caches' in window) {
          const keys = await caches.keys();
          await Promise.all(keys.map(name => caches.delete(name)));
        }
      } finally {
        const hasReloaded = sessionStorage.getItem('chunk-reload-retry');

        if (!hasReloaded) {
          sessionStorage.setItem('chunk-reload-retry', 'true');
          location.reload();
        } else {
          sessionStorage.removeItem('chunk-reload-retry');
        }
      }
      return;
    }

    console.error('Global error:', error);
  }
}
